import LabServiceModel from "@/models/LabServiceModel";

export default class AnalyteRangeModel extends LabServiceModel {

  modelName() {
    return 'analyte-range';
  }

  defaults() {
    return {
      id: null,
      analyte_id: null,
      attribute_list_id: null,
      sub_attribute_list_id: null,
      irrigated: null,
      very_low: null,
      low: null,
      high: null,
      very_high: null,
      created_by: null,
      updated_by: null,
      deleted_by: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      analyte: null,
    }
  }

  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      analyte_id: (val) => (this.nullStringMutator(val)),
      attribute_list_id: (val) => (this.nullStringMutator(val)),
      sub_attribute_list_id: (val) => (this.nullStringMutator(val)),
      irrigated: (val) => (this.nullNumberMutator(val)),
      very_low: (val) => (this.nullNumberMutator(val)),
      low: (val) => (this.nullNumberMutator(val)),
      high: (val) => (this.nullNumberMutator(val)),
      very_high: (val) => (this.nullNumberMutator(val)),
      created_by: (val) => (this.nullStringMutator(val)),
      updated_by: (val) => (this.nullStringMutator(val)),
      deleted_by: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }

  validation() {
    return {}
  }
}
